export interface PublicLandingRule {
  code: string;
  section: string;
  title: string;
  text: string;
  version: number;
}

export const PUBLIC_LANDING_RULES: PublicLandingRule[] = [
  {
    code: "1.1",
    section: "General rules",
    title: "Global chat",
    text: "Global chat must be kept in English to ensure all players can communicate and understand one another.\nDiscussions about rule breaks, toxic behavior, political topics, and religious debates are not permitted in global chat.",
    version: 1
  },
  {
    code: "1.2",
    section: "General rules",
    title: "Be respectful",
    text: "Treat everyone with respect. Toxicity, harassment, discrimination or excessive insults are not allowed.",
    version: 1
  },
  {
    code: "1.3",
    section: "General rules",
    title: "Location dropping",
    text: "You may only share your own location. Sharing your location to receive assistance during a fight, or sharing another player's location to have them hunted or killed, is not allowed.\nAllowed: “The bridge at delta's is blocked, taxes are needed to cross”\nNot allowed: “I am sitting at delta's” → “There are 2 rexes here”",
    version: 1
  },
  {
    code: "2.1",
    section: "Fairplay",
    title: "Exploits, hacks and bugs",
    text: "Using bugs, glitches, unintended mechanics, or third-party software to gain an advantage is prohibited.",
    version: 1
  },
  {
    code: "2.2",
    section: "Fairplay",
    title: "Scouting",
    text: "Using another player or a different species to scout, locate, or reveal the position of other players for the purpose of hunting, attacking, or gaining an unfair advantage is not allowed.\nThis also means no streamsniping or using outside information to locate players.",
    version: 1
  },
  {
    code: "3.1",
    section: "Combat rules",
    title: "Revenge killing",
    text: "Revenge killing is not allowed. After being killed, you must avoid the group that killed you for at least 30 minutes. If you encounter them again during that time, you may defend yourself if attacked, but you may not seek them out or re-engage them, unless both parties agree.\nThis does not mean you can go back to that location, wait until that 30 minute timer is over and kill them right after that timer.",
    version: 1
  },
  {
    code: "3.2",
    section: "Combat rules",
    title: "3rd-partying",
    text: "Apexes such as Tyrannosaurus, Stegosaurus and Triceratops are not allowed to third party.\nThird partying is allowed if you attack both sides or scare away the aggressor without favoring either party. Repeatedly helping the same group or consistently choosing one side will be considered mixpacking and may result in a strike.\nApexes can attack right after the fight ends.\nGroups can always defend each other, as long as you're grouped up before the fight starts.",
    version: 1
  },
  {
    code: "3.3",
    section: "Combat rules",
    title: "Friendly bait",
    text: "Using 2-call or verbally claiming to be friendly or peaceful, then attacking or killing that player is not allowed. This applies to all members of your group.\nLaying next to someone or talking to someone does not mean they're friendly. Wiggling does not guarantee friendliness.\nDeinos may accept taxes but they don't have to honour them.",
    version: 1
  },
  {
    code: "3.4",
    section: "Combat rules",
    title: "Bodyshielding",
    text: "Protectingly hovering or purposely hiding behind a different species counts as a rule break.\nIf someone is purposely hiding behind you, you are not in the wrong but the one using you as shield is.\nYou can use your own group as body shield.",
    version: 1
  },
  {
    code: "3.4",
    section: "Combat rules",
    title: "Kill denial",
    text: "Intentionally denying another player their kill during combat by exploiting glitches, drowning yourself, jumping off cliffs, or otherwise intentionally causing your own death is prohibited.\nEntombing is allowed.",
    version: 1
  },
  {
    code: "3.5",
    section: "Combat rules",
    title: "Groups",
    text: "Players may not kill members of their own group or leave a group to immediately attack or kill former group members. Doing so to bypass group rules or gain an unfair advantage is prohibited.",
    version: 1
  },
  {
    code: "4.1",
    section: "Carnivores",
    title: "Mixpacking",
    text: "Carnivores may never group, hunt, or travel with other species.",
    version: 1
  },
  {
    code: "4.2",
    section: "Carnivores",
    title: "Overpacking",
    text: "Carnivores must stay within the group limits of their own species maximum pack limit at all times.\nJuveniles can stay if the same species. They have to leave after 50%.",
    version: 1
  },
  {
    code: "4.3",
    section: "Carnivores",
    title: "Foodsharing",
    text: "You can't take care of other species but you may share your food with juveniles (Juvenile is under 50% growth). When you share your food with a juvenile, you have to split up right after. You can use food as a “food tax” for deinos but they don't have to honour it and may still attack you.",
    version: 1
  },
  {
    code: "4.4",
    section: "Carnivores",
    title: "Buying corpses",
    text: "Buying corpses for someone else is prohibited. Buying corpses during a fight is also not allowed and may result in a strike.",
    version: 1
  },
  {
    code: "4.5",
    section: "Carnivores",
    title: "Deinosuchus",
    text: "Deinosuchus may share the same body of water with other Deinosuchus, but they may not defend or assist Deinosuchus outside of their own group during fights. Beipiosaurus and Pteranodon are exempt and may peacefully coexist with Deinosuchus.",
    version: 1
  },
  {
    code: "5.1",
    section: "Herbivores & omnivores",
    title: "Mixed herd",
    text: "Herbivores and omnivores of different species may mix together in groups of up to 4 players in total. Juveniles do not count to the maximum group limit. They have to leave after 50% if the group is full. Dryos, beipis and hypsis do not count towards the group limit.\nWhile being in a mixed herd, doesn't mean the faster species can run around to scout for the group. You have to stay close together as a group.",
    version: 1
  },
  {
    code: "5.2",
    section: "Herbivores & omnivores",
    title: "Group hopping",
    text: "Switching between groups to assist another group in combat or gain an unfair advantage, then returning to your original group is prohibited.",
    version: 1
  },
  {
    code: "6.1",
    section: "Nesting rules",
    title: "Nest killing",
    text: "After being nested in, you may not intentionally kill your siblings or parents, including immediately after leaving the nest or group.",
    version: 1
  },
  {
    code: "6.2",
    section: "Nesting rules",
    title: "Nest griefing",
    text: "Intentionally destroying the nest or killing eggs after being nested in for the purpose of griefing or disrupting gameplay is not allowed.",
    version: 1
  },
  {
    code: "REPORT",
    section: "Reporting and staff decisions",
    title: "Report rule breaks privately",
    text: "If you witness a rule break, do not argue about it in global chat or on Discord. Instead, create a ticket in report-a-player with F2/video evidence (for as long as F2 is not working) and let staff handle the situation. They will review the evidence and determine whether a rule was actually broken. Toxic or argumentative behavior may also result in a strike.",
    version: 1
  },
  {
    code: "REVIEW",
    section: "Reporting and staff decisions",
    title: "Staff decisions and reviews",
    text: "Staff decisions are final. If you disagree you are always welcome to open a ticket and talk about it.",
    version: 1
  }
];
